import type { ChangelogEntry } from "../types";

/** Kundeliste v2: tellere, hast-gruppering, GEEK-kolonner og «Våre kunder». */
export const KUNDELISTE_V2_2026_10: ChangelogEntry = {
  id: "2026-10-20-kundeliste-v2",
  date: "2026-10-20",
  title: "Kundelisten svarer på hvem du må gjøre noe med nå",
  summary:
    "Fire tellere øverst (Forfalt, Denne uken, Kjølner innen 30 dager, GEEK i pipe) som også er filtre, rader gruppert etter hva som haster, og sorterbare kolonner for neste steg, GEEK i pipe, GEEK levert siste tolv måneder og siste kontakt.",
  sections: [
    {
      heading: "Kundelisten",
      items: [
        {
          title: "Tellere som også er filtre",
          kind: "nytt",
          featureFlag: "feature_crm_kundekort",
          body: "Øverst står Forfalt, Denne uken, Kjølner innen 30 dager og GEEK i pipe. Klikk en teller for å se bare de kundene, klikk igjen for å nullstille. Tellerne regnes på alle kunder, uavhengig av søk og filtre.",
        },
        {
          title: "Radene gruppert etter hast, eller sortert på en kolonne",
          kind: "nytt",
          featureFlag: "feature_crm_kundekort",
          body: "Som standard («Haster mest») står kundene i gruppene Forfalt, Denne uken, Kjølner innen 30 dager og Rolig, og i Rolig står de med mest GEEK i pipe først. Klikk en kolonneoverskrift for å sortere flatt på den, klikk igjen for å snu retningen. Rader uten verdi står alltid sist.",
        },
        {
          title: "Nye kolonner, alle beløp er GEEK",
          kind: "forbedret",
          featureFlag: "feature_crm_kundekort",
          body: "Kunde (med logo og bransje), Status med kjølnedato, Eier (eller «ta eierskap»), Neste steg, GEEK i pipe, GEEK levert siste 12 mnd og Siste kontakt. Org.nr, e-post og kontaktperson er ikke kolonner lenger, men søket treffer dem fortsatt.",
        },
      ],
    },
  ],
};
